if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        // Формы и элементы (проверяем на null)
        this.form = this.querySelector('form');
        if (!this.form) return;

        // submit button
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton ? this.submitButton.querySelector('span') : null;

        // ensure variant input is enabled if present
        var vInput = this.variantIdInput;
        if (vInput) vInput.disabled = false;

        // cart drawer / notification (may be custom element)
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

        // add listener
        if (this.form) {
          this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        }

        if (document.querySelector('cart-drawer') && this.submitButton) {
          try { this.submitButton.setAttribute('aria-haspopup', 'dialog'); } catch (e) {}
        }

        this.hideErrors = this.dataset && this.dataset.hideErrors === 'true';
        this.error = false;
        this.errorMessageWrapper = null;
        this.errorMessage = null;
      }

      onSubmitHandler(evt) {
        if (evt && typeof evt.preventDefault === 'function') evt.preventDefault();

        // prevent double submit
        if (this.submitButton && this.submitButton.getAttribute && this.submitButton.getAttribute('aria-disabled') === 'true') {
          return;
        }

        this.handleErrorMessage(false);

        if (this.submitButton && this.submitButton.setAttribute) {
          try { this.submitButton.setAttribute('aria-disabled', true); } catch (e) {}
        }
        if (this.submitButton && this.submitButton.classList) {
          try { this.submitButton.classList.add('loading'); } catch (e) {}
        }

        var spinner = this.querySelector('.loading__spinner');
        if (spinner && spinner.classList) spinner.classList.remove('hidden');

        // build fetch config
        var config = fetchConfig ? fetchConfig('javascript') || {} : { method: 'POST', headers: {} };
        config = config || {};
        config.method = 'POST';
        // For FormData do not set Content-Type
        if (config.headers && config.headers['Content-Type']) {
          try { delete config.headers['Content-Type']; } catch (e) {}
        } else {
          config.headers = config.headers || {};
        }
        config.headers['X-Requested-With'] = 'XMLHttpRequest';

        var formData = new FormData(this.form);

        // Quick Add / PDP: ensure variant id
        var variantId = formData.get('id');
        if (!variantId || variantId === 'null' || variantId === 'undefined') {
          var idEl = this.form.querySelector('[name="id"], select[name="id"], [data-variant-id]');
          if (idEl) {
            // try value first
            try {
              variantId = idEl.value || idEl.getAttribute('data-variant-id') || '';
            } catch (e) {
              variantId = idEl.getAttribute && idEl.getAttribute('data-variant-id') || '';
            }
            if (variantId) formData.set('id', variantId);
          }
        }

        // If still no id — show error and stop
        if (!formData.get('id')) {
          this.handleErrorMessage && this.handleErrorMessage('{{ "products.product.unavailable" | t }}');
          if (this.submitButton && this.submitButton.classList) this.submitButton.classList.remove('loading');
          if (this.submitButton && this.submitButton.setAttribute) this.submitButton.setAttribute('aria-disabled', false);
          if (spinner && spinner.classList) spinner.classList.add('hidden');
          return;
        }

        // support cart drawer / notification — append sections if cart provides method
        if (this.cart) {
          try {
            if (typeof this.cart.getSectionsToRender === 'function') {
              var sections = this.cart.getSectionsToRender().map(function(s){ return s.id; });
              formData.append('sections', sections);
            }
          } catch (e) {}
          try {
            formData.append('sections_url', window.location.pathname);
          } catch (e) {}
          try {
            if (typeof this.cart.setActiveElement === 'function') {
              this.cart.setActiveElement(document.activeElement);
            }
          } catch (e) {}
        }

        config.body = formData;

        // First fetch: add to cart
        fetch('/cart/add.js', config)
          .then(function(r){ return r.json(); })
          .then(function(response){
            // If Shopify returns response.status on error (e.g. 422/400)
            if (response && response.status) {
              // show error using handler if available
              if (typeof this.handleErrorMessage === 'function') {
                this.handleErrorMessage(response.errors || response.description || 'Unable to add to cart');
              } else {
                console.warn('handleErrorMessage not available', response);
              }

              // show sold-out message if present
              var soldOutMessage = this.submitButton ? this.submitButton.querySelector('.sold-out-message') : null;
              if (soldOutMessage) {
                if (this.submitButton && this.submitButton.setAttribute) this.submitButton.setAttribute('aria-disabled', true);
                if (this.submitButtonText && this.submitButtonText.classList) this.submitButtonText.classList.add('hidden');
                if (soldOutMessage.classList) soldOutMessage.classList.remove('hidden');
                this.error = true;
              }
              // stop further processing for errors
              throw new Error('add-error');
            }

            // success: continue to next stage — get full cart JSON (some themes expect a second fetch)
            return response;
          }.bind(this))
          .then(function(successfulResponse){
            // If no cart UI (no this.cart), redirect to cart page
            if (!this.cart) {
              try {
                window.location = window.routes ? window.routes.cart_url : '/cart';
              } catch (e) { window.location = '/cart'; }
              return;
            }

            // publish event to subscribers, measure performance if available
            var startMarker = (typeof CartPerformance !== 'undefined' && typeof CartPerformance.createStartingMarker === 'function') ? CartPerformance.createStartingMarker('add:wait-for-subscribers') : null;

            if (!this.error) {
              // publish cartUpdate and wait for subscribers
              var pub = (typeof publish === 'function') ? publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: successfulResponse
              }) : Promise.resolve();

              pub.then(function(){
                if (startMarker && typeof CartPerformance.measureFromMarker === 'function') {
                  CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
                }
              }).catch(function(){ /* ignore subscriber errors */ });
            }

            this.error = false;

            // If we are inside a quick-add modal, hide it and then render cart when modal closed
            var quickAddModal = this.closest && this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener('modalClosed', (function(){
                setTimeout((function(){
                  if (typeof CartPerformance !== 'undefined' && typeof CartPerformance.measure === 'function') {
                    CartPerformance.measure("add:paint-updated-sections", (function(){
                      try { if (this.cart && typeof this.cart.renderContents === 'function') this.cart.renderContents(successfulResponse); } catch(e){}
                    }).bind(this));
                  } else {
                    try { if (this.cart && typeof this.cart.renderContents === 'function') this.cart.renderContents(successfulResponse); } catch(e){}
                  }
                }).bind(this), 0);
              }).bind(this), { once: true });
              if (typeof quickAddModal.hide === 'function') quickAddModal.hide(true);
            } else {
              if (typeof CartPerformance !== 'undefined' && typeof CartPerformance.measure === 'function') {
                CartPerformance.measure("add:paint-updated-sections", (function(){
                  try { if (this.cart && typeof this.cart.renderContents === 'function') this.cart.renderContents(successfulResponse); } catch(e){}
                }).bind(this));
              } else {
                try { if (this.cart && typeof this.cart.renderContents === 'function') this.cart.renderContents(successfulResponse); } catch(e){}
              }
            }
          }.bind(this))
          .catch(function(err){
            // If we threw 'add-error' earlier, this will catch it; handle other exceptions too
            if (err && err.message === 'add-error') {
              // already handled UI for add-error
            } else {
              console.error('Add to cart failed:', err);
              if (typeof this.handleErrorMessage === 'function') {
                this.handleErrorMessage('Something went wrong. Please try again.');
              }
            }
          }.bind(this))
          .finally((function(){
            // cleanup UI state
            if (this.submitButton && this.submitButton.classList) this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList && this.cart.classList.contains('is-empty')) {
              try { this.cart.classList.remove('is-empty'); } catch(e){}
            }
            if (!this.error && this.submitButton && this.submitButton.removeAttribute) this.submitButton.removeAttribute('aria-disabled');
            var spinnerEl = this.querySelector('.loading__spinner');
            if (spinnerEl && spinnerEl.classList) spinnerEl.classList.add('hidden');

            // performance measurement hook (if available)
            try {
              if (typeof CartPerformance !== 'undefined' && typeof CartPerformance.measureFromEvent === 'function') {
                CartPerformance.measureFromEvent("add:user-action", evt);
              }
            } catch (e) {}
          }).bind(this));
      }

      handleErrorMessage(errorMessage) {
        // if hideErrors flag set — do nothing
        if (this.hideErrors) return;

        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        // toggle hidden attribute
        try {
          if (errorMessage) {
            this.errorMessageWrapper.removeAttribute('hidden');
            if (this.errorMessage) this.errorMessage.textContent = errorMessage;
          } else {
            this.errorMessageWrapper.setAttribute('hidden', '');
          }
        } catch (e) {}
      }

      toggleSubmitButton(disable, text) {
        // default disable true if not provided
        var shouldDisable = (typeof disable === 'undefined') ? true : !!disable;
        if (!this.submitButton) return;
        if (shouldDisable) {
          try { this.submitButton.setAttribute('disabled', 'disabled'); } catch(e){}
          if (text && this.submitButtonText) this.submitButtonText.textContent = text;
        } else {
          try { this.submitButton.removeAttribute('disabled'); } catch(e){}
          if (this.submitButtonText) this.submitButtonText.textContent = (window.variantStrings && window.variantStrings.addToCart) || 'Add to cart';
        }
      }

      get variantIdInput() {
        if (!this.form) return null;
        try {
          return this.form.querySelector('[name=id]');
        } catch (e) {
          return null;
        }
      }
    }
  );
}
